<template>
  <b-modal
    :id="modalId"
    :title="photoModalTitle"
    size="lg"
    no-close-on-backdrop
    hide-footer
    static
    @hidden="resetPhotoModal"
  >
    <template #modal-header-close>
      <i class="fa fa-close" />
    </template>

    <template v-if="activePhoto">
      <div class="photo-viewer-stage rounded mb-3 position-relative">
        <img
          class="photo-viewer-image"
          :src="activePhoto.url"
          :alt="title"
        >

        <div
          v-if="photos.length > 1"
          class="photo-viewer-nav d-flex align-items-center"
        >
          <b-button
            variant="link"
            class="text-white p-1"
            :disabled="photoIndex === 0"
            @click="photoIndex -= 1"
          >
            <i class="fa fa-chevron-left" />
          </b-button>
          <span class="text-white font-size-sm px-2">
            {{ photoIndex + 1 }} / {{ photos.length }}
          </span>
          <b-button
            variant="link"
            class="text-white p-1"
            :disabled="photoIndex >= photos.length - 1"
            @click="photoIndex += 1"
          >
            <i class="fa fa-chevron-right" />
          </b-button>
        </div>
      </div>
    </template>

    <b-button
      variant="primary"
      block
      @click="$bvModal.hide(modalId)"
    >
      Close
    </b-button>
  </b-modal>
</template>

<script>
export default {
  name: 'WorkOrderActivitiesTimelineItemPhotoModal',
  props: {
    photos: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: 'Photos',
    },
    modalId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      photoIndex: 0,
    };
  },
  computed: {
    activePhoto() {
      return this.photos[this.photoIndex] || null;
    },
    photoModalTitle() {
      const title = this.title || 'Photos';
      if (!this.activePhoto) {
        return title;
      }
      return `${title} · ${this.photoIndex + 1} of ${this.photos.length}`;
    },
  },
  methods: {
    openPhoto(index) {
      this.photoIndex = index;
      this.$bvModal.show(this.modalId);
    },
    resetPhotoModal() {
      this.photoIndex = 0;
    },
  },
};
</script>

<style scoped>
.photo-viewer-stage {
  background: #111;
  overflow: hidden;
}

.photo-viewer-image {
  display: block;
  width: 100%;
  max-height: 65vh;
  object-fit: contain;
}

.photo-viewer-nav {
  position: absolute;
  left: 50%;
  bottom: 0.75rem;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.65);
  border-radius: 2rem;
  padding: 0.15rem 0.5rem;
}

.photo-viewer-nav .btn:disabled {
  opacity: 0.35;
}
</style>
